var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecordAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "plus_1_",
    "data-name": "plus (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38066",
    "data-name": "Path 38066",
    d: "M10,0A10,10,0,1,0,20,10,10.011,10.011,0,0,0,10,0Zm0,19.231A9.231,9.231,0,1,1,19.231,10,9.242,9.242,0,0,1,10,19.231Z",
    fill: "#2279fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38067",
    "data-name": "Path 38067",
    d: "M24.139,18.594H18.991V13.466a.448.448,0,1,0-.9,0v5.128H12.948a.467.467,0,0,0,0,.932H18.1V25.12a.448.448,0,1,0,.9,0V19.526h5.148a.467.467,0,0,0,0-.932Z",
    transform: "translate(-8.543 -9.145)",
    fill: "#2279fe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordAdd);
export default __webpack_public_path__ + "static/media/Record Add.91fe2a58.svg";
export { ForwardRef as ReactComponent };